import { z } from "zod";
import { KycSchema, UserSchema } from "../treezor/index.js";
import updateTreezorAccountCreator from "./updateTreezorAccountCreator.js";

export default {
  params: updateTreezorAccountCreator.params
    .omit({ legalRole: true, isEffectiveBeneficiary: true })
    .extend({ title: UserSchema.shape.title.exclude(["", "MLLE"]) }),
  response: z.object({
    user: UserSchema.extend({ kyc: KycSchema.optional() }),
  }),
};
